import { Epic } from 'redux-observable';
import { ofType } from '@alycecom/utils';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { handleError, handlers, IResponse, IListResponse } from '@alycecom/services';

import { setSorting } from '../products/products.actions';
import { SORT_RECOMMENDED } from '../../constants/sorting.constants';

import {
  loadAvailableTagsFail,
  loadAvailableTagsRequest,
  loadAvailableTagsSuccess,
  loadSelectedTagsFail,
  loadSelectedTagsRequest,
  loadSelectedTagsSuccess,
  saveSelectedTagsFail,
  saveSelectedTagsRequest,
  saveSelectedTagsSuccess,
} from './tags.actions';
import { ISelectedTags, ITagData } from './tags.types';

export const loadSelectedTagsEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(loadSelectedTagsRequest),
    switchMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/${hashId}/tags`).pipe(
        map(({ data }: IResponse<ISelectedTags | null>) => loadSelectedTagsSuccess(data)),
        catchError(handleError(handlers.handleAnyError(loadSelectedTagsFail))),
      ),
    ),
  );

export const loadAvailableTagsEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(loadAvailableTagsRequest),
    switchMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/${hashId}/marketplace/tags`).pipe(
        map(({ data }: IListResponse<ITagData>) => loadAvailableTagsSuccess(data)),
        catchError(handleError(handlers.handleAnyError(loadAvailableTagsFail))),
      ),
    ),
  );

export const saveSelectedTagsEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(saveSelectedTagsRequest),
    switchMap(({ payload: { hashId, tagIds, displayedTags } }) =>
      apiService.post(`/api/recipient/${hashId}/tags`, { body: { tagIds, displayedTags } }).pipe(
        mergeMap(({ data }: IResponse<ISelectedTags>) => {
          if (tagIds.length > 0) {
            return [saveSelectedTagsSuccess(data), setSorting(SORT_RECOMMENDED)];
          }
          return [saveSelectedTagsSuccess(data)];
        }),
        catchError(handleError(handlers.handleAnyError(saveSelectedTagsFail))),
      ),
    ),
  );

export default [loadSelectedTagsEpic, loadAvailableTagsEpic, saveSelectedTagsEpic];
